export default "__VITE_ASSET__sIT7Or07__"